import React from 'react';
import PropTypes from 'prop-types';

import { Droppable } from 'react-beautiful-dnd';
import StepSessionWithTopic from './StepSessionWithTopic';

export default function StepSession({ position, assignTopic, onTopicRemove }) {
  if (assignTopic) {
    return <StepSessionWithTopic assignTopic={assignTopic} position={position} onTopicRemove={onTopicRemove} />;
  }
  return (
    <Droppable droppableId={`session_${position}`}>
      {(provided, snapshot) => (
        <div
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...provided.droppableProps}
          ref={provided.innerRef}
          className={`selected-topic icon-with-text ${snapshot.isDraggingOver ? 'drag-over' : ''}`}
        >
          <div className="counting-icon" />
          <div className="topic-placeholder ms-2">Drag and drop the topic card here</div>
          <div className="d-none">
            {provided.placeholder}
          </div>
        </div>
      )}
    </Droppable>
  );
}

StepSession.propTypes = {
  position: PropTypes.number.isRequired,
  assignTopic: PropTypes.object,
  onTopicRemove: PropTypes.func,
};

StepSession.defaultProps = {
  assignTopic: null,
  onTopicRemove: () => {},
};
